/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlIntegrationUrl
 */
export interface ControlIntegrationUrl {
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationUrl
     */
    url: string;
}

/**
 * Check if a given object implements the ControlIntegrationUrl interface.
 */
export function instanceOfControlIntegrationUrl(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function ControlIntegrationUrlFromJSON(json: any): ControlIntegrationUrl {
    return ControlIntegrationUrlFromJSONTyped(json, false);
}

export function ControlIntegrationUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlIntegrationUrl {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function ControlIntegrationUrlToJSON(value?: ControlIntegrationUrl | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

